import { captureException } from '@sentry/react';

import { getHttpErrorStatus } from '@/helpers/get-http-error-status';

export const captureSignUpError = (error: unknown): void => {
  const status = getHttpErrorStatus(error) ?? 'unknown';

  const signUpError = new Error(`Sign-up failed with HTTP status ${status}`);
  signUpError.name = 'SignUpError';

  captureException(signUpError, {
    tags: { flow: 'sign-up', status },
  });
};
